export default "__VITE_ASSET__td4gS_4D__"